import Vue from "vue";

export default {
  state: {
    isKiosk: false,
    showKioskSplashOnHome: true,
    hideSetupButton: false,

    isAndroidKiosk: false,
    androidKioskUrl: '',
    androidJsonAppConfig: '',
    bluetoothDevices: '',
    allPaymentStores: '',
    softposTerminalState: 'N/A',
    storePicked: {storeId: '', storeName: ''},
    printerLog: '',
  },
  actions: {},
  mutations: {
    storePicked(state, v) {
      return state.storePicked = v;
    },
    softposTerminalState(state, v) {
      return state.softposTerminalState = v;
    },
    setIsKiosk(state, v) {
      return state.isKiosk = !!v;
    },
    setShowKioskSplashOnHome(state, v) {
      return state.showKioskSplashOnHome = !!v;
    },
    hideSetupButton(state, v) {
      Vue.ls.set('hideSetupButton', !!v);
      return state.hideSetupButton = !!v;
    },

    bluetoothDevices(state, v) {
      state.bluetoothDevices = v;
    },

    allPaymentStores(state, v) {
      state.allPaymentStores = v;
    },

    isAndroidKiosk(state, v) {
      state.isAndroidKiosk = v;
    },
    androidJsonAppConfig(state, v) {
      state.androidJsonAppConfig = v;
    },
    androidKioskUrl(state, v) {
      state.androidKioskUrl = v;
    },
    printerLog(state, v) {
      state.printerLog = v;
    },
  },
  getters: {
    storePicked: (state) => {
      return state.storePicked;
    },
    softposTerminalState: (state) => {
      return state.softposTerminalState;
    },
    isKiosk: (state) => {
      return state.isKiosk;
    },
    showKioskSplashOnHome: (state) => {
      return state.showKioskSplashOnHome;
    },
    hideSetupButton: (state) => {
      return state.hideSetupButton;
    },

    bluetoothDevices: (state) => {
      return state.bluetoothDevices;
    },
    allPaymentStores: (state) => {
      return state.allPaymentStores;
    },
    isAndroidKiosk: (state) => {
      return state.isAndroidKiosk;
    },
    androidJsonAppConfig: (state) => {
      return state.androidJsonAppConfig;
    },
    androidKioskUrl: (state) => {
      return state.androidKioskUrl;
    },
    printerLog: (state) => {
      return state.printerLog;
    },
  }
};
